import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowLeft, ArrowUpRight } from "lucide-react";
import { getOne, getContent } from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/motion/Reveal";
import { ProjectCard } from "../components/cards/ProjectCard";
import { CTASection } from "../components/home/FinancialBenefits";

export default function RegionDetail() {
  const { slug } = useParams();
  const { t, tc } = useLang();
  const [region, setRegion] = useState(null);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getOne("regions", slug).then(setRegion).catch(() => setRegion(false));
    getContent("projects").then((all) => setProjects(all.filter((p) => p.region === slug))).catch(() => {});
  }, [slug]);

  if (region === null) return <div className="pt-40 pb-40 text-center text-charcoal/50" data-testid="region-loading">{t.common.loading}</div>;
  if (region === false) return <div className="pt-40 pb-40 text-center text-charcoal/50" data-testid="region-not-found">{t.common.regionNotFound}</div>;

  return (
    <>
      <SEO title={tc(region.name)} description={tc(region.description)} image={region.image} />
      <PageHeader overline={t.regions.overline} title={tc(region.name)} sub={tc(region.tagline)} image={region.image} />

      <section className="py-10 sm:py-14 bg-white">
        <div className="max-w-[1200px] mx-auto px-5 sm:px-8">
          <Link to="/regions" data-testid="back-to-regions" className="inline-flex items-center gap-2 text-charcoal/60 hover:text-green transition-colors mb-10 text-sm">
            <ArrowLeft className="w-4 h-4 rtl:rotate-180" /> {t.nav.regions}
          </Link>

          <div className="grid lg:grid-cols-3 gap-12">
            <Reveal className="lg:col-span-2">
              <p className="text-charcoal/65 leading-relaxed text-lg">{tc(region.description)}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="bg-lightgray rounded-2xl p-7">
                <h3 className="overline mb-5">{t.regions.highlights}</h3>
                <ul className="space-y-3">
                  {(tc(region.highlights) || []).map((h, i) => (
                    <li key={i} className="flex items-start gap-3 text-charcoal/70 text-sm"><Check className="w-4 h-4 text-green mt-0.5 shrink-0" /> {h}</li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>

          {projects.length > 0 && (
            <div className="mt-20">
              <h2 className="font-display text-3xl text-charcoal mb-10">{t.regions.exploreProjects}</h2>
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-0">
                {projects.map((p, i) => <ProjectCard key={p.slug} project={p} index={i} />)}
              </div>
            </div>
          )}
        </div>
      </section>
      <CTASection />
    </>
  );
}
